import { useContext, useEffect } from 'react';
import { Button, Grid, SvgIcon, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { ReactComponent as UploadIcon } from '../../images/cloud-upload.svg';
import DoneImageEN from '../../images/Done.svg';
import ErrorImageEN from '../../images/ErrorX.svg';

import IdUploadGIFEN from '../../images/UploadPhotoEN.gif';
import IdUploadGIFES from '../../images/UploadPhotoES.gif';
import vouchedRetryIcon from '../../images/vouchedRetryIcon.png';
import { SidebarStyles as classes } from './SidebarStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import CustomTooltip from '../Tooltip/CustomTooltip';
import { COLOR2, ID_UPLOAD_TEXT, ORIENTAL_ORANGE, UPLOAD_ID_PASSPORT } from '../../constants';
import { businessMapping } from '../../services/businessMapping';

function IdUploadSidebar({ uploadSuccessStatus, vouchedTigger, businessFlow }) {
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const {
    idUploadStatus,
    setIdUploadStatus,
    personalInformation,
    businessAccountInfo,
    productName,
    countryModal,
    vouchedUploadCount,
    setVouchedUploadCount,
    setAddress,
    flowInvitation,
    idError,
    setIdError,
  } = leadGenerationContext;

  useEffect(() => {
    if (uploadSuccessStatus === null || uploadSuccessStatus === undefined) {
      setIdUploadStatus(null);
    } else if (uploadSuccessStatus) {
      if (countryModal) {
        setIdUploadStatus(false);
      } else {
        setIdUploadStatus(true);
      }
    } else {
      setIdUploadStatus(false);
    }
    const expiryDate = businessMapping(productName)
      ? businessAccountInfo?.vouchedIDExpiryDate
      : personalInformation?.vouchedIDExpiryDate;
    if (expiryDate) {
      const diffInDate = moment
        .tz(expiryDate, 'MM/DD/YYYY', moment.tz.guess(true))
        .diff(moment.tz(moment.tz.guess(true)), 'days');
      if (diffInDate < 0) {
        setIdError('Expired ID');
        setIdUploadStatus(false);
      } else {
        setIdError(null);
      }
    }
  }, [uploadSuccessStatus, leadGenerationContext.language]);
  useEffect(() => {
    let elementId;
    if (
      (businessAccountInfo?.vouchedJobId && countryModal) ||
      (personalInformation?.vouchedJobId && countryModal)
    ) {
      if (idUploadStatus === null || idUploadStatus === false) {
        setIdUploadStatus(false);
      }
    } else {
      if (idUploadStatus === true) {
        elementId = 'idUploadSuccessImg';
      } else if (idUploadStatus === false) {
        elementId = 'idUploadFailImg';
      } else {
        elementId = 'initialIdUploadImg';
      }
      const element = document.getElementById(elementId);
      if (element) {
        element.focus();
        element.scrollIntoView();
        document.getElementById('uploadIdPassportTitle')?.scrollIntoView();
      }
    }
  }, [uploadSuccessStatus, countryModal]);

  const uploadHandler = () => {
    if (businessMapping(productName) && flowInvitation !== 'invitation-form') {
      setAddress(true);
    }
    if (idUploadStatus === true) {
      setVouchedUploadCount(vouchedUploadCount + 1);
    }
    vouchedTigger();
  };

  const idUploadError = () => {
    if (idError) {
      return (
        <span
          data-testid="expired_id"
          style={{
            color: COLOR2,
            margin: '2px',
            display: 'block',
            textAlign: 'center',
            fontSize: '16px',
          }}
        >
          {t(idError, { defaultValue: `* ${idError}` })}
        </span>
      );
    }
  };

  let idErrJsx;
  const vouchedIdErrorStatus = () => {
    if (leadGenerationContext.vouchedIdErrorStatus) {
      if (leadGenerationContext.language === 'EN') {
        idErrJsx = (
          <Box component="div" sx={classes.new_addr_gif}>
            <Box
              component="img"
              sx={classes.new_addr_gif_width_adjust}
              src={IdUploadGIFEN}
              alt={ID_UPLOAD_TEXT}
            />
          </Box>
        );
      } else {
        idErrJsx = (
          <Box component="div" sx={classes.new_addr_gif}>
            <Box
              component="img"
              sx={classes.new_addr_gif_width_adjust}
              src={IdUploadGIFES}
              alt="Sube tu identificación con foto para completar la solicitud. Las ID's acceptadas son tu licencia de conducir, pasaporte, tarjeta de pasaporte o ID militar"
            />
          </Box>
        );
      }
    }
    return idErrJsx;
  };
  useEffect(() => {
    let element = '';
    element = document.getElementById('uploadContainer_vouched');
    if (idUploadStatus === true) {
      if (element) {
        element.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#E37617,#E37617 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#E37617,#E37617 7px,transparent 8px,transparent 15px) !important; background:#FFFDF2;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      }
    } else if (idUploadStatus === false) {
      if (element) {
        element.setAttribute(
          'style',
          'background-image: repeating-linear-gradient(0deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#D71721,#D71721 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#D71721,#D71721 7px,transparent 8px,transparent 15px) !important; background:#FFF2F2;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
        );
      }
    } else {
      element?.setAttribute(
        'style',
        'background-image: repeating-linear-gradient(0deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(90deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(180deg,#808285,#808285 7px,transparent 8px,transparent 15px),repeating-linear-gradient(270deg,#808285,#808285 7px,transparent 8px,transparent 15px) !important; background:#F4F4F4;background-size: 1px 100%, 100% 1px, 1px 100%, 100% 1px;background-repeat: no-repeat;background-position: 0 0, 0 0, 100% 0, 0 100%'
      );
    }
  }, [idUploadStatus]);
  return (
    <Grid container sx={classes.idUpload_container}>
      <Grid size={{ xs: 12 }} sx={classes.id_upload_grid_error}>
        <div style={{ width: '100%' }}>
          <div style={{ width: '100%' }}>
            <Typography
              variant="h2"
              role="heading"
              id="uploadIdPassportTitle"
              sx={classes.top_text_upload_id}
              aria-label={t(UPLOAD_ID_PASSPORT, { defaultValue: UPLOAD_ID_PASSPORT })}
            >
              {t(UPLOAD_ID_PASSPORT, { defaultValue: UPLOAD_ID_PASSPORT })}
              {(businessMapping(productName) === 'Linea de Credito Comercial' ||
                businessMapping(productName) === 'Tarjeta de Credito Comercial' ||
                businessMapping(productName) === 'Prestamo Comercial') &&
              flowInvitation !== 'invitation-form' ? (
                ''
              ) : (
                <span style={{ fontSize: '22px', marginLeft: '5px', color: ORIENTAL_ORANGE }}>
                  *
                </span>
              )}
              <span style={{ marginLeft: '10px', opacity: 1 }}>
                <CustomTooltip
                  placement="top"
                  text={t(`PreviewConsent`, {
                    defaultValue: `Sensitive information will be encrypted, registered and safeguarded in our systems. You must provide a valid and unexpired primary ID to confirm your information and identity. Accepted ID are: driver’s license, passport and passport card.*Digital ID screenshots are not allowed.`,
                  })}
                />
              </span>
            </Typography>
            <Box
              component="span"
              id="uploadContainer_vouched"
              sx={[classes.uploadContainerID, classes.boxID, classes.box_aID]}
            >
              {idUploadStatus === null && (
                <>
                  <Box component="span" sx={classes.imgUploadId}>
                    <SvgIcon
                      role="graphic"
                      viewBox="0 0 64 64"
                      titleAccess={t('Upload Icon', { defaultValue: 'Upload Icon' })}
                      component={UploadIcon}
                      aria-label={t('Upload Icon', { defaultValue: 'Upload Icon' })}
                      data-testid="upload_icon"
                      // onClick={handleClickOpen}
                      class={classes.iconSize}
                    />
                  </Box>
                  <Box component="span" sx={classes.uploadIdText}>
                    <Typography id="uploadIdText" variant="subtitle1">
                      {t('idProcess', {
                        defaultValue: 'Click button to validate your identity',
                      })}
                    </Typography>
                  </Box>
                  <Grid container>
                    <Grid item xs={12}>
                      <Box component="span" sx={classes.camera_icon}>
                        <Button
                          disableFocusRipple
                          sx={classes.idUpload_button}
                          data-testid="uploadTestId"
                          onClick={uploadHandler}
                        >
                          {t('Start ID Verification', { defaultValue: 'Start ID Verification' })}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              )}
              {idUploadStatus === true && (
                <Box component="div" sx={classes.statusContainerAcc} aria-label="Upload Success">
                  <img src={DoneImageEN} alt="upload Success" height="54px" width="54px" />
                  <Box component="span" sx={classes.doneText}>
                    {t('Done', {
                      defaultValue: 'Done',
                    })}
                  </Box>
                </Box>
              )}
              {idUploadStatus === false && (
                <Box component="div" sx={classes.statusContainerAcc}>
                  <img
                    id="idUploadFailImg"
                    src={ErrorImageEN}
                    data-testid="uploadTestId2"
                    onClick={uploadHandler}
                    onKeyDown={uploadHandler}
                    tabIndex="-1"
                    alt="Upload Failed"
                    height="54px"
                    width="54px"
                  />
                  <Box component="span" sx={classes.errorText}>
                    {t('Try Again', {
                      defaultValue: 'Try Again',
                    })}
                  </Box>
                </Box>
              )}
            </Box>
            {idUploadError()}
            {vouchedUploadCount <= 2 && !!idUploadStatus ? (
              <div
                style={{
                  color: '#661C69',
                  margin: '15px',
                  display: 'block',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '700',
                  font: 'Arial',
                  lineHeight: '20px',
                  cursor: 'pointer',
                }}
              >
                <span onClick={() => uploadHandler()} onKeyDown={() => uploadHandler()}>
                  <img
                    // className={classes.new_addr_gif_width_adjust}
                    src={vouchedRetryIcon}
                    alt="vouched Retry Icon"
                    style={{ paddingRight: '7px' }}
                  />
                  {t('Repeat Verification Process', {
                    defaultValue: 'Repeat Verification Process',
                  })}
                </span>
                <span
                  style={{
                    marginLeft: '10px',
                    opacity: 1,
                    cursor: 'auto',
                  }}
                >
                  <CustomTooltip
                    placement="top"
                    text={t(
                      `You can repeat the verification process up to 3 times in case some information has been fetched incorrectly.`,
                      {
                        defaultValue: `You can repeat the verification process up to 3 times in case some information has been fetched incorrectly.`,
                      }
                    )}
                  />
                </span>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </Grid>
      <Grid size={{ xs: 12 }} sx={classes.id_upload_grid}>
        {vouchedIdErrorStatus()}
      </Grid>
    </Grid>
  );
}

export default IdUploadSidebar;

IdUploadSidebar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  uploadSuccessStatus: PropTypes.any,
  vouchedTigger: PropTypes.func,
  businessFlow: PropTypes.bool,
};
